const translations = {
  fr: {
    radio: {
      radioSelectionPageTitle: 'Stations',
      errorWhileChangingStation: 'Une erreur est survenue lors du changement de station',
      noAccessToStation: 'Vous n\'avez accès à aucune radio',
      radioHasAnomaliesMessage: 'Nous avons détecté des anomalies avec vos statistiques et nous sommes actuellement en train de travailler sur la situation.',
    },
  },
  en: {
    radio: {
      radioSelectionPageTitle: 'Stations',
      errorWhileChangingStation: 'An error occurred while changing radio station',
      noAccessToStation: 'You don\'t have access to any radio station',
      radioHasAnomaliesMessage: 'We have detected anomalies in your statistics. We are currently working on the issue.',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/radio/i18n/radio.js